import React from 'react';

// 이 프로젝트 최초 목업(StatsCard.js, 커밋 ec0f743)이 카드 배경 자체를
// 옅은 색으로 채우는 방식이었다 - 나중에 실데이터로 갈아끼우면서 흰
// 배경+아이콘만 색칠하는 방식으로 바뀌었는데, 그때 그 화려함도 같이
// 빠져서 밋밋해졌다는 피드백으로 원래 방식을 되살렸다. 배경(bg-100)·
// 아이콘 배지(진한 색)·값 텍스트(진한 색) 세 군데 다 같은 색 계열이라
// 카드 하나가 통째로 그 색으로 읽힌다.
const COLOR_MAP = {
  indigo: { bg: 'bg-indigo-50', border: 'border-indigo-100', badge: 'bg-indigo-500', value: 'text-indigo-700' },
  emerald: { bg: 'bg-emerald-50', border: 'border-emerald-100', badge: 'bg-emerald-500', value: 'text-emerald-700' },
  amber: { bg: 'bg-amber-50', border: 'border-amber-100', badge: 'bg-amber-500', value: 'text-amber-700' },
  rose: { bg: 'bg-rose-50', border: 'border-rose-100', badge: 'bg-rose-500', value: 'text-rose-700' },
};

// 대시보드 숫자 카드 하나. icon은 lucide-react 컴포넌트를 그대로 넘긴다.
const MetricCard = ({ icon: Icon, label, value, sub, color = 'indigo' }) => {
  const colors = COLOR_MAP[color] || COLOR_MAP.indigo;
  return (
    <div className={`rounded-xl border ${colors.border} ${colors.bg} shadow-sm p-4`}>
      <div className="flex items-center gap-2">
        <div className={`flex-shrink-0 inline-flex items-center justify-center w-8 h-8 rounded-lg ${colors.badge}`}>
          <Icon className="w-4 h-4 text-white" />
        </div>
        <div className="text-xs font-medium text-gray-600">{label}</div>
      </div>
      <div className={`mt-2.5 text-2xl font-bold tabular-nums truncate ${colors.value}`}>{value}</div>
      {sub && <div className="mt-0.5 text-xs text-gray-500 truncate">{sub}</div>}
    </div>
  );
};

export default MetricCard;
